import { Routes } from '@angular/router';
import { ProjectsComponent } from '@core/projects/projects.component';
import { ActivitiesComponent } from '@core/activities/activities.component';
import { MsalGuard } from '@azure/msal-angular';
import { ErrorComponent } from '@core/error/error.component';
import { MetricsComponent } from '@core/metrics/metrics.component';
import { DocsComponent } from '@core/docs/docs.component';
import { SiteAdminComponent } from '@core/site-admin/site-admin.component';
import { ChangelogComponent } from '@core/changelog/changelog.component';
import { CompareComponent } from '@extensions/compare/compare.component';

export const routes: Routes = [
  { path: 'docs', component: DocsComponent },
  { path: 'projects', component: ProjectsComponent, canActivate: [MsalGuard] },
  { path: 'activities', component: ActivitiesComponent, canActivate: [MsalGuard] },
  { path: 'activities/:id', component: ActivitiesComponent, canActivate: [MsalGuard] },
  { path: 'tool/compare', component: CompareComponent, canActivate: [MsalGuard] },
  { path: 'metrics', component: MetricsComponent, canActivate: [MsalGuard] },
  { path: 'admin', component: SiteAdminComponent, canActivate: [MsalGuard] },
  { path: 'changelog', component: ChangelogComponent, canActivate: [MsalGuard] },
  { path: 'login', component: ErrorComponent },
  { path: '**', redirectTo: 'projects' }
];
